/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Top_RatedInputs */

const en_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Rated`)
};

const ar_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأعلى تقييمًا`)
};

const bn_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টপ রেটেড`)
};

const de_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestbewertet`)
};

const es_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejor valorados`)
};

const fr_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les mieux notés`)
};

const pt_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhor avaliado`)
};

const zh_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评价最高`)
};

const tr_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Çok Oy Alanlar`)
};

const ru_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие рейтинги`)
};

const pl_about_top_rated = /** @type {(inputs: About_Top_RatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najwyżej oceniane`)
};

/**
* | output |
* | --- |
* | "Top Rated" |
*
* @param {About_Top_RatedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const about_top_rated = /** @type {((inputs?: About_Top_RatedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Top_RatedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_about_top_rated(inputs)
	if (locale === "bn") return bn_about_top_rated(inputs)
	if (locale === "de") return de_about_top_rated(inputs)
	if (locale === "es") return es_about_top_rated(inputs)
	if (locale === "fr") return fr_about_top_rated(inputs)
	if (locale === "pt") return pt_about_top_rated(inputs)
	if (locale === "zh") return zh_about_top_rated(inputs)
	if (locale === "tr") return tr_about_top_rated(inputs)
	if (locale === "ru") return ru_about_top_rated(inputs)
	if (locale === "pl") return pl_about_top_rated(inputs)
	return en_about_top_rated(inputs)
});